export const GET_SCHOOL_BY_PRIVATE_CENTER_QUERY = 'GET_SCHOOL_BY_PRIVATE_CENTER_QUERY';
export const GET_OPS_ADMIN_RESIT_ACTION_QUERY = 'GET_OPS_ADMIN_RESIT_ACTION_QUERY';
export const GET_OOP_ADMIN_RESIT_COORDINATOR_BY_SCHOOL_QUERY =
  'GET_OOP_ADMIN_RESIT_COORDINATOR_BY_SCHOOL_QUERY';
export const POST_OOP_ADMIN_RESIT_SEARCH_CANDIDATE_QUERY =
  'POST_OOP_ADMIN_RESIT_SEARCH_CANDIDATE_QUERY';
export const POST_OOP_ADMIN_RESIT_CANDIDATE_REGISTER_DETAILS_QUERY =
  'POST_OOP_ADMIN_RESIT_CANDIDATE_REGISTER_DETAILS_QUERY';
export const GET_OOP_ADMIN_INDIVIDUAL_RESIT_CANDIDATE_REGISTER_DETAILS_QUERY =
  'GET_OOP_ADMIN_INDIVIDUAL_RESIT_CANDIDATE_REGISTER_DETAILS_QUERY';
export const GET_OOP_ADMIN_RESIT_EXAM_LEVELS_OPTION_QUERY =
  'GET_OOP_ADMIN_RESIT_EXAM_LEVELS_OPTION_QUERY';
export const GET_OOP_ADMIN_RESIT_SCHOOL_OPTION_QUERY = 'GET_OOP_ADMIN_RESIT_SCHOOL_OPTION_QUERY';
export const GET_OOP_ADMIN_RESIT_SCHOOL_CODE_OPTION_QUERY =
  'GET_OOP_ADMIN_RESIT_SCHOOL_CODE_OPTION_QUERY';
export const POST_OOP_ADMIN_RESIT_CANDIDATE_REGISTER_DETAILS_DOWNLOAD_QUERY =
  'POST_OOP_ADMIN_RESIT_CANDIDATE_REGISTER_DETAILS_DOWNLOAD_QUERY';
